import queryClient from '../query-client';
import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { EntityTypeEnum } from '../types/entity';

export type CreateFYIEntity = {
    id: number;
    name: string;
    groupId?: number;
    businessStructure: EntityTypeEnum;
    financialYearEndMonth: number;
    financialYearEndDay: number;
};

export type CreateFYIEntitiesRequest = {
    entities: CreateFYIEntity[];
};

export type CreateFYIEntitiesResponse = {
    entitiesOnboarded: number;
    existingEntitiesMapped: number;
};

async function createFYIEntities(req: CreateFYIEntitiesRequest): Promise<CreateFYIEntitiesResponse> {
    const { data } = await api.post(`/fyi-docs/entities`, req);
    return data;
}

export function useCreateFYIEntities(): UseMutationResult<CreateFYIEntitiesResponse, AxiosError, CreateFYIEntitiesRequest, unknown> {
    return useMutation(createFYIEntities, {
        onSettled: () => queryClient.invalidateQueries(['entities']),
    });
}
